import {
  AfterViewInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  OnInit,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  ChangeDetectionStrategy,
  OnDestroy,
  TrackByFunction
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACL_WTAX_LINE_COLUMNS, ColumnOptions } from '@core';
import { ACLService } from '@delon/acl';
import { _HttpClient, SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { TranxSummaryComponent } from '@shared-feature/components/tranx-summary/tranx-summary.component';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { removeRecentAgentAction } from 'src/app/actions/agent';
import { removeRecentCustomerAction } from 'src/app/actions/customer/action';
import { removeRecentProjectAction } from 'src/app/actions/project';
import { removeRecentStockAction } from 'src/app/actions/stock';
import { removeRecentTaxAction } from 'src/app/actions/tax';
import { removeRecentTermAction } from 'src/app/actions/term';
import { ColumnOptionsComponent } from 'src/app/components/col-options/col-options.component';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';
import { FurtherDescriptionComponent } from 'src/app/shared-feature/components/f-desc/f-desc.component';
import { CustomerInfoModalComponent } from 'src/app/shared-feature/components/modal/customer-info-modal/customer-info-modal.component';
import { StockSelectComponent } from 'src/app/shared-feature/components/select/stock-select/stock-select.component';
import { DocBaseService } from 'src/app/shared-feature/services/_base/doc-base.service';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';
import { AutoCodeService } from 'src/app/shared-feature/services/auto-code.service';
import { TransactionDetailColumnAdjustService } from 'src/app/shared-feature/services/transaction-detail-column-adjust.service';
import { TranscationDetailKeyKownService } from 'src/app/shared-feature/services/transcation-detail-key-kown.service';

import { PaginatedTableComponent } from '../../../../shared/components/paginated-table/paginated-table.component';
import { DoListService } from '../../_providers/do-list.service';
import { DoService } from '../../_providers/do.service';
import { AttachmentTableComponent } from 'src/app/shared/components/attachment-table/attachment-table.component';
import { AttachmentChangePayload } from 'src/app/shared/models/attachment-change.model';

@Component({
  selector: 'app-sale-do-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less'],
  standalone: false,
  providers: [
    {
      provide: DocListBaseService,
      useExisting: forwardRef(() => DoListService)
    },
    {
      provide: DocBaseService,
      useExisting: forwardRef(() => DoService)
    },
    {
      provide: DoService,
      useFactory: (injector: Injector) => new DoService(injector),
      deps: [Injector]
    },
    {
      provide: AutoCodeService,
      useFactory: (http: _HttpClient) => new AutoCodeService(http),
      deps: [_HttpClient]
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DoDetailComponent extends PaginatedTableComponent<DoService>
  implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy
{
  @ViewChild('custModal') customerInfoModal!: CustomerInfoModalComponent;

  @ViewChildren(StockSelectComponent)
  stockSelections!: QueryList<StockSelectComponent>;

  @ViewChild('notesTextArea') notesTextArea!: ElementRef;
  @ViewChild('columnOption') columnOptionComponent!: ColumnOptionsComponent;
  @ViewChild('itemDetailsTable', { static: false })
  nzTableComponent?: NzTableComponent<any>;
  @ViewChild('customerNameInput') customerNameInput!: any;
  @ViewChild('attachmentTable') attachmentTable!: AttachmentTableComponent;

  public override newlyAddedLine: boolean = false;
  private visibleColumnsChanged: boolean = false;
  private columnPositionReset: boolean = false;

  private initialColumnOrder: string[] = [];

  get id() {
    return this.route.snapshot.params['id'];
  }
  get form() {
    return this.dataSrv.form;
  }
  get details() {
    return this.form.controls.itemDetails;
  }
  get collapsed() {
    return this.settings.layout.collapsed;
  }

  columns: ColumnOptions[] = [
    {
      key: 'stock',
      title: 'Stock',
      width: '150px',
      align: 'left',
      name: 'stock',
      visible: true
    },
    {
      key: 'desc',
      title: 'Description',
      width: '240px',
      align: 'left',
      name: 'desc',
      visible: true
    },
    {
      key: 'fDesc',
      title: 'F. Desc',
      width: '80px',
      align: 'center',
      name: 'fDesc',
      visible: true
    },
    {
      key: 'project',
      title: 'Project',
      width: '120px',
      align: 'left',
      acl: { ability: ['m1.256'] },
      name: 'project',
      visible: false
    },
    {
      key: 'qty',
      title: 'Qty',
      width: '120px',
      align: 'right',
      name: 'qty',
      visible: true
    },
    {
      key: 'uom',
      title: 'UOM',
      width: '120px',
      align: 'left',
      name: 'uom',
      visible: true
    },
    {
      key: 'unitPrice',
      title: 'Unit Price',
      width: '120px',
      align: 'right',
      name: 'unitPrice',
      visible: true
    },
    {
      key: 'discount',
      title: {
        text: 'Discount',
        optionalHelp:
          'Discounts can either be a number or a percentage. For percentage discounts, include the "%" symbol.'
      },
      width: '120px',
      align: 'right',
      name: 'discount',
      visible: true
    },
    {
      key: 'discountAmount',
      title: 'Discount Amt.',
      width: '120px',
      align: 'right',
      name: 'discountAmount',
      visible: false
    },
    {
      key: 'amount',
      title: 'Amount',
      width: '120px',
      align: 'right',
      name: 'amount',
      visible: false
    },
    {
      key: 'netAmount',
      name: 'netAmount',
      title: 'Net Amount',
      width: '120px',
      align: 'right',
      visible: false
    },
    {
      key: 'ref1',
      name: 'ref1',
      title: 'Num Ref 1',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'ref2',
      name: 'ref2',
      title: 'Num Ref 2',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'dateRef1',
      name: 'dateRef1',
      title: 'Date Ref 1',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'dateRef2',
      name: 'dateRef2',
      title: 'Date Ref 2',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'stockLocation',
      title: 'Location',
      width: '120px',
      acl: { ability: ['m1.8', 'm1.64'], mode: 'allOf' },
      align: 'left',
      name: 'stockLocation',
      visible: false
    },
    {
      key: 'taxCode',
      title: 'Tax',
      width: '120px',
      align: 'left',
      acl: { ability: ['m1.512'] },
      name: 'taxCode',
      visible: true
    },
    {
      key: 'taxAmount',
      title: 'Tax Amount',
      width: '120px',
      align: 'right',
      acl: { ability: ['m1.512'] },
      name: 'taxAmount',
      visible: false
    },
    {
      key: 'taxExemptionRate',
      name: 'taxExemptionRate',
      title: 'Exempted Rate',
      width: '120px',
      align: 'left',
      acl: { ability: ['m1.512'], mode: 'allOf' },
      visible: false
    },
    {
      key: 'taxExemptionAmount',
      name: 'taxExemptionAmount',
      title: 'Exempted Tax Amount',
      width: '120px',
      align: 'right',
      acl: { ability: ['m1.512'], mode: 'allOf' },
      visible: false
    },
    {
      key: 'taxAmountAdjustment',
      title: 'Tax Adjustment',
      width: '120px',
      align: 'right',
      acl: { ability: ['m1.512'] },
      name: 'taxAmountAdjustment',
      visible: false
    },
    {
      key: 'rentalLeaseExemptedRate',
      title: 'Rental/Lease Exempted Rate',
      width: '120px',
      align: 'left',
      acl: { ability: ['country.MY', 'm1.512'], mode: 'allOf' },
      name: 'rentalLeaseExemptedRate',
      visible: false
    },
    {
      key: 'rentalLeaseExemptedTaxAmount',
      title: 'Rental/Lease Exempted Tax Amount',
      width: '120px',
      align: 'right',
      acl: { ability: ['country.MY', 'm1.512'], mode: 'allOf' },
      name: 'rentalLeaseExemptedTaxAmount',
      visible: false
    },
    {
      title: 'Tariff Code',
      width: '120px',
      align: 'left',
      acl: { ability: ['country.MY', 'm1.8388608'], mode: 'allOf' },
      name: 'tariffCode',
      visible: false
    },
    {
      key: 'taxExemptNo',
      title: 'Tax Exempt No.',
      width: '120px',
      align: 'left',
      acl: { ability: ['country.MY', 'm1.8388608'], mode: 'allOf' },
      name: 'taxExemptNo',
      visible: false
    },
    {
      key: 'wTaxCode',
      title: 'W/Tax',
      width: '120px',
      align: 'left',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxCode',
      visible: true
    },
    {
      key: 'wTaxAmount',
      title: 'W/Tax Amount',
      width: '120px',
      align: 'right',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxAmount',
      visible: false
    },
    {
      key: 'wTaxAmountAdjustment',
      title: 'W/Tax Adjustment',
      width: '120px',
      align: 'right',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxAmountAdjustment',
      visible: false
    },
    {
      key: 'referenceNo',
      name: 'referenceNo',
      title: 'Ref. No',
      width: '240px',
      align: 'left',
      visible: false
    },
    {
      key: 'stockCategoryCode',
      name: 'stockCategoryCode',
      title: 'Stock Category',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'stockGroupCode',
      name: 'stockGroupCode',
      title: 'Stock Group',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'stockClassCode',
      name: 'stockClassCode',
      title: 'Stock Class',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'stockAlternateName',
      name: 'stockAlternateName',
      title: 'Stock Alternate Name',
      width: '120px',
      align: 'left',
      visible: false
    },
    {
      key: 'minPrice',
      name: 'minPrice',
      title: 'Min Price',
      width: '120px',
      align: 'right',
      visible: false
    },
    {
      key: 'lastSellingPrice',
      name: 'lastSellingPrice',
      title: 'Last Selling Price',
      width: '120px',
      align: 'right',
      visible: false
    },
    {
      key: 'lastPurchasePrice',
      name: 'lastPurchasePrice',
      title: 'Last Purchase Price',
      width: '120px',
      align: 'right',
      visible: false
    }
  ];

  @ViewChild('tranxSummary') tranxSummary!: TranxSummaryComponent;
  getDepositRecords() {
    return this.tranxSummary.getDeposits();
  }

  constructor(
    private route: ActivatedRoute,
    public msgSrv: NzMessageService,
    public override dataSrv: DoService,
    public acl: ACLService,
    private modalSrv: NzModalService,
    protected override cdr: ChangeDetectorRef,
    public settings: SettingsService,
    public router: Router,
    public override keyDownService: TranscationDetailKeyKownService,
    public columnAdjustService: TransactionDetailColumnAdjustService,
    private store: Store<{
      term: { recentTerm: any };
      agent: { recentAgent: any };
      project: { recentProject: any };
      customer: { recentCustomer: any };
      stock: { recentStock: any };
      tax: { recentTax: any };
    }>,
    private userDefaultService: UserDefaultService
  ) {
    // Call the parent constructor with required parameters
    super(dataSrv, cdr, keyDownService);
    
    // DoDetailComponent-specific initialization
    this.dataSrv.setComponentRef(this);

    this.dataSrv.newLineAdded$.subscribe(() => {
      this.newlyAddedLine = true;
    });

    this.dataSrv.lineValueChanged.subscribe(({ line, controlName }) => {
      const index = this.dataSrv.itemDetails.controls.indexOf(line);
      this.keyDownService.focusNextElement(
        index,
        controlName,
        this.visibleColumns,
        this.editableCells.toArray()
      );
    });
  }

  override visibleColumns: ColumnOptions[] = [];
  initialColumns: ColumnOptions[] = [];
  private destroy$ = new Subject<void>();
  recentStockControlIndex?: number;
  recentTaxControlIndex?: number;
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @ViewChildren('inputWrapper') inputWrappers!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.store.dispatch(removeRecentAgentAction());
    this.store.dispatch(removeRecentCustomerAction());
    this.store.dispatch(removeRecentProjectAction());
    this.store.dispatch(removeRecentTermAction());
    this.store.dispatch(removeRecentStockAction());
    this.store.dispatch(removeRecentTaxAction());
    if (this.id == 0) {
      this.onProjectCreate();
      this.onTermAdded();
      this.onAgentAdded();
      this.onAddNewCustomer();
      this.onStockCreate();
      this.onTaxCreate();
    }
  }
  private onTaxCreate() {
    this.store
      .select('tax')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentTax === null) return;
        if (
          isNull(this.recentTaxControlIndex) ||
          isUndefined(this.recentTaxControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentTaxControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentTaxControlIndex
        );
        rowControl.controls.taxCode.setValue(state.recentTax);
        rowControl.controls.taxCodeId.setValue(state.recentTax.id);
      });
  }
  private onStockCreate() {
    this.store
      .select('stock')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentStock === null) return;
        if (
          isNull(this.recentStockControlIndex) ||
          isUndefined(this.recentStockControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentStockControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentStockControlIndex
        );
        rowControl.controls.stock.setValue(state.recentStock);
        rowControl.controls.stockId.setValue(state.recentStock.id);
        rowControl.controls.stockLocation.setValue(state.recentStock.location);
        rowControl.controls.stockId.setValue(state.recentStock.locationId);
      });
  }
  private onProjectCreate() {
    this.store
      .select('project')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentProject === null) return;
        if (
          this.form.controls.projectId.value ||
          this.form.controls.project.value
        )
          return;
        this.form.controls.project.setValue(state.recentProject);
        this.form.controls.projectId.setValue(state.recentProject.id);
      });
  }
  private onTermAdded() {
    this.store
      .select('term')
      .pipe(takeUntil(this.destroy$))
      .subscribe(term => {
        if (this.dataSrv.form.controls.termId.value) return;
        if (term.recentTerm) {
          this.dataSrv.form.controls.termId.setValue(term.recentTerm.id);
          this.dataSrv.form.controls.term.setValue(term.recentTerm);
        }
      });
  }
  private onAgentAdded() {
    this.store
      .select('agent')
      .pipe(takeUntil(this.destroy$))
      .subscribe(agent => {
        if (this.dataSrv.form.controls.agentId.value) return;
        if (agent.recentAgent) {
          this.dataSrv.form.controls.agentId.setValue(agent.recentAgent.id);
          this.dataSrv.form.controls.agent.setValue(agent.recentAgent);
        }
      });
  }
  onAddNewCustomer() {
    this.store
      .select('customer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentCustomer === null) return;
        this.form.controls.customer.setValue(state.recentCustomer);
        this.form.controls.customerId.setValue(state.recentCustomer?.id);
        this.form.controls.customerName.setValue(state.recentCustomer?.name);
        this.form.controls.customerPhone.setValue(
          state.recentCustomer?.phoneNo1
        );
        this.form.controls.customerTinType.setValue(
          state.recentCustomer?.tinType
        );
      });
  }
  ngAfterViewInit(): void {
    /**
     * column data should in take after onInit because to make the column chooser ngOninit data done processed
     * if not column in here will be overwrite by column chooser, the console log data will confused
     */

    this.visibleColumns = this.columns.filter(
      col => (!col.acl || this.acl.canAbility(col.acl)) && col.visible
    );

    this.initialColumns = JSON.parse(JSON.stringify(this.visibleColumns));
    this.initialColumnOrder = this.initialColumns.map(col => col.name);

    this.columnAdjustService.setInitialColumn(this.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('do');
    if (savedOrder) {
      this.visibleColumns.sort(
        (a, b) => savedOrder[a.key || ''] - savedOrder[b.key || '']
      );
    }

    // if column visible have update
    this.columnOptionComponent.visibleColiumnsChanged$.subscribe(() => {
      this.visibleColumnsChanged = true;
    });

    // if column position want to be reset
    this.columnOptionComponent.columnPositionReset$.subscribe(
      (initialOrder: string[]) => {
        this.initialColumnOrder = initialOrder;
        this.columnPositionReset = true;
      }
    );
    this.inputWrappers.forEach(wrapper => {
      this.userDefaultService.setRequiredValidation(wrapper);
    });
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    col.width = `${width}px`;
  }

  populateDOAddress(data: any) {
    this.dataSrv.populateDOAddress(data);
  }

  updateLatestRate() {
    this.dataSrv.updateLatestRate();
  }

  validateRemainingQty(event: any, row: any) {
    // future: retrieve value from setting
    const allowTransferMore = true;
    if (!allowTransferMore) {
      let qty: number = event.newValue;
      /// do checking, get the right qty value;
      if (row.transferFromQuotationDetail) {
        const remainingQty = row.transferFromQuotationDetail.remainingQty;
        if (+qty > +remainingQty) event.newValue = remainingQty;
      }
      if (row.transferFromSalesOrderDetail) {
        const remainingQty = row.transferFromSalesOrderDetail.remainingQty;
        if (+qty > +remainingQty) event.newValue = remainingQty;
      }
    }
  }

  fDescriptionModal(line: any) {
    const modal = this.modalSrv.create({
      nzTitle: 'F. Desc',
      nzContent: FurtherDescriptionComponent,
      nzWidth: '800px',
      nzOnOk: component => {
        const instance = modal.getContentComponent();
        line.controls.docFurtherDescription.setValue(instance.getPersistedHtml());
      }
    });
    const instance = modal.getContentComponent();
    instance.fdescHtml = line.controls.docFurtherDescription.value;
  }

  updateCustModal(data: any) {
    this.dataSrv.updateCustInfo(data);
  }

  onCustomerChange() {
    if (this.dataSrv.editing){
      // Focus on customer name field after customer selection
      setTimeout(() => {
        if (this.customerNameInput) {
          this.customerNameInput.focus();
        }
      }, 100);
    }
  }

  openCustModal() {
    // Pass existing data to ensure data recovery can be done when changes are cancelled
    this.customerInfoModal.show(this.dataSrv.form.value, 'DO');
  }

  ngAfterViewChecked() {
    if (this.newlyAddedLine) {
      this.focusNewLineStockSelect();
      this.newlyAddedLine = false;
    }

    // Phase 1: Update visible columns if there are changes
    if (this.visibleColumnsChanged) {
      // Create a map of the current visible columns
      const currentVisibleMap = new Map(
        this.visibleColumns.map(col => [col.name, col])
      );

      // Filter out columns that are no longer visible or accessible based on ACL
      this.visibleColumns = this.visibleColumns.filter(
        col =>
          (!col.acl || this.acl.canAbility(col.acl)) &&
          this.columns.find(c => c.name === col.name)?.visible
      );

      // Add any new visible columns that were not in the current map
      this.columns.forEach(col => {
        if (
          (!col.acl || this.acl.canAbility(col.acl)) &&
          col.visible &&
          !currentVisibleMap.has(col.name)
        ) {
          this.visibleColumns.push(col);
        }
      });

      // Reset the flag and detect changes to update the view
      this.visibleColumnsChanged = false;
      this.cdr.detectChanges();
    }

    // Phase 2: Reset column positions if requested
    if (this.columnPositionReset) {
      // Reorder the visible columns based on the initial column order
      this.visibleColumns = this.initialColumnOrder
        .map(name => this.visibleColumns.find(col => col.name === name))
        .filter(col => col !== undefined) as ColumnOptions[];

      // Reset the column order in the column adjust service
      this.columnAdjustService.resetColumnOrder('do');

      // Reset the flag and detect changes to update the view
      this.columnPositionReset = false;
      this.cdr.detectChanges();
    }
  }

  private focusNewLineStockSelect() {
    const stockSelectionArray = this.stockSelections.toArray();
    if (stockSelectionArray.length > 0) {
      const newLineStockSelect =
        stockSelectionArray[stockSelectionArray.length - 1];
      newLineStockSelect.focus();
    }
  }
  columnOrder: string[] = [];
  override selectComponentArray: string[] = [
    'stock',
    'project',
    'uom',
    'stockLocation',
    'taxCode',
    'wTaxCode',
    'taxAmountAdjustment',
    'wTaxAmountAdjustment'
  ];
  @ViewChildren('editableCell') override editableCells!: QueryList<ElementRef>;


  timestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedTimestamp = null;
    if (this.settings.user['country'] === 'MY')
      formattedTimestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.settings.user['country'] === 'PH')
      formattedTimestamp = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.dataSrv.form.controls.notes.value)
      formattedTimestamp = `${this.dataSrv.form.controls.notes.value}\n${formattedTimestamp}`;

    this.dataSrv.form.controls.notes.setValue(formattedTimestamp);
    this.notesTextArea.nativeElement.focus();
  }

  collectAttachmentChanges(): AttachmentChangePayload | null {
    if (this.attachmentTable && this.attachmentTable.getDeferredAttachmentChanges) {
      return this.attachmentTable.getDeferredAttachmentChanges();
    }
    return null;
  }

  clearAttachmentChanges(): void {
    if (this.attachmentTable && this.attachmentTable.clearDeferredChanges) {
      this.attachmentTable.clearDeferredChanges();
    }
  }

}
